<template>
  <v-app>
    <core-multi-lang />
    <v-container fill-height fluid grid-list-xl class="main-layout_inner">
      <v-layout justify-center wrap>
        <!-- inline edit table -->
        <v-flex xs12 class="pt-xs-0 pt-0">
          <v-flex>
            <h4 class="main_title">{{ $t("Checkin.intro2") }}</h4>
            <h4 class="main_title">
              {{ $t("Checkin.please-start-the-pre-check-in-system") }}
            </h4>
            <p class="message-desc">
              {{ $t("Checkin.new-intro").replace("%h%", getName) }}
            </p>
            <p class="message-desc mt-3">{{ $t("Checkin.second-intro") }}</p>
          </v-flex>
        </v-flex>
      </v-layout>
      <div class="main_btn">
        <v-btn
          class="btn-custom"
          v-bind:disabled="!valid"
          v-bind:class="
            valid ? 'btn-submit-green' : 'btn-submit-green-disabled'
          "
          v-on:click="handleNextToEnterInformationScreen()"
        >
          {{ $t("Checkin.next") }}
        </v-btn>
      </div>
    </v-container>
  </v-app>
</template>

<style scoped lang="scss">
.message-heading {
  color: rgb(66 66 66) !important;
  font-size: 19.5px !important;
  font-weight: 600 !important;
}
.message-desc {
  color: rgb(91 91 91) !important;
  font-size: 14px !important;
  margin-bottom: 30px;
}
.message-label {
  color: rgb(97 110 126);
  font-size: 17px !important;
}
.message-infor {
  color: rgb(112 124 138);
  font-size: 14px !important;
  margin-bottom: 0;
}

.btn-submit-green {
  width: 100%;
  background-color: rgb(97 110 126) !important;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  color: #fff;
}
</style>
<script>
import StringUtil from "@/shared/StringUtil"
import { mapGetters, mapState } from "vuex"

// 同行者の入口の紹介画面（名前に反して代表者は使わない。同行者画面の戻り先 `/checkin`）。
//
// 以前は `/checkin?isLogin=0&userId=` で開かれると、無認証の personReset でパスワードを
// 再発行し、そのまま personLogin していた（宿泊者IDだけで入れた）。無認証の personReset は
// 廃止する（DMS-1268-H）ので、ここではログインしない。同行者は招待（DMS-1268-F）か
// 引き継ぎコード（DMS-1268-E）で入る。
export default {
  props: {
    nextRoute: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    valid: true,
  }),

  computed: {
    getEnterInformationScreenUrl() {
      return "GuestCheckinUploadPassport"
    },
    ...mapGetters(["reserve_guests", "reserve_user", "reserve", "bookingId"]),
    ...mapState({
      settings: (state) => state.settings,
    }),

    getName() {
      return this.settings ? this.settings.name : ""
    },
  },
  watch: {},

  created() {
    // this.fetchReserve()
  },

  methods: {
    handleNextToEnterInformationScreen() {
      this.$router.push("/guest-upload-passport")
    },

    fetchReserve() {
      this.$store
        .dispatch("getReserved")
        .then((res) => {
          this.valid = true
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dateToString(date) {
      return StringUtil.dateToString(date)
    },
  },
}
</script>

<style lang="scss"></style>
